// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__-qzuQ","pagination__items":"Pagination_pagination__items__lnQES","pagination__item_selected":"Pagination_pagination__item_selected__gvkWr"};